<script>
export default {
  name: "LeftMenu"
}
</script>


<template>
  <div>
    <button type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
      <v-icon icon="mdi-menu" size="50"/>
    </button>
    <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasExampleLabel">Выберите рабочую область</h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="nav flex-column nav-pills me-1 pt-3" style="width: 300px" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <button v-show="props.showUsersTable" @click="$emit('show', '1')" class="nav-link active btn btn-lg btn-primary btn-block text-start"
                id="left-user-tab" data-bs-dismiss="offcanvas" type="button" role="tab"
                aria-controls="left-user" aria-selected="true">
          Управление пользователями
        </button>
        <button v-show="props.showAdminTable" @click="$emit('show', '2')" class="nav-link active btn btn-lg btn-primary btn-block text-start"
                id="left-user-tab" data-bs-dismiss="offcanvas" type="button" role="tab"
                aria-controls="left-user" aria-selected="true">
          Рабочее пространство
        </button>
        <button v-show="props.showTA" @click="$emit('show', '3')" class="nav-link active btn btn-lg btn-primary btn-block text-start"
                id="left-user-tab" data-bs-dismiss="offcanvas" type="button" role="tab"
                aria-controls="left-user" aria-selected="true">
          Транспортный учет
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  showUsersTable: {
    type: Boolean,
    default: false,
  },
  showTA: {
    type: Boolean,
    default: false,
  },
  showAdminTable: {
    type: Boolean,
    default: false,
  }
})
</script>


<style scoped>
  button {
    margin-bottom: 5px;
  }
</style>